import { Component, OnInit, ViewChild } from "@angular/core";
import { CAPService } from "../../../core/services/cap-service";

import { GridOptions } from "ag-grid-community";

//import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { PagerService } from "../../../core/services/pager.service";
import { DatePipe } from "@angular/common";
import { MatDatepicker } from "@angular/material/datepicker";
import { formatDate } from "@angular/common";
//import { isNullOrUndefined } from 'util';
import * as ExcelJS from 'exceljs';

//import * as $ from 'jquery';
declare let $: any;

@Component({
  selector: "app-myprofile",
  templateUrl: "./myprofile.component.html",
  styleUrls: ["./myprofile.component.css"],
})
export class MyprofileComponent implements OnInit {
  @ViewChild("PeriodFrom") PeriodFrom: MatDatepicker<Date>;
  @ViewChild("PeriodTo") PeriodTo: MatDatepicker<Date>;
  IsShowMarkCalls = false;
  IsShowMarkActive = true;
  IsShowMyMarkCalls = false;
  IsShowApproveCalls = false;
  IsShowMyApprovedCalls = false;
  IsShowWBSEActive = true;
  IsMyAuthcodeActive = true;
  IsAuthcodeUpdateWBS = true;
  IsShowProfileActive = true;
  IsShowApproveActive = true;
  IsShowReportActive = true;
  showModalWBS: boolean;
  showModalMarkCalls: boolean;
  //showModalApproveCalls: boolean;
  showReport:boolean = false;
  showWBSElement = false;
  showApprover = false;
  displayPopUp = "none";
  divMarkCallDetails = "none";
  divWBSElement = "none";
  displayWBS = "none";
  displayApproveCalls = "none";
  displayApprovedCalls = "none";
  displayWBSMark = "none";
  divApprover = "none";
  btnApprovecancel = "none";
  btnEditApprovecancel = "none";
  isCheckAll = false;
  select_all_data = false;
  ActiveTab = 1;
  Rundate: string;

  public columnDefs: any;
  public excelStyles;
  public gridOptions: GridOptions;
  public rowData = [];
  public gridApi;
  public gridColumnApi;
  usecase;
  txtProfileWBS;
  date = new Date();
  day = this.date.getDate();
  profile;
  WBS;
  ApproveCallsOptionWBS;
  ApproveCallsOptionWBS1;
  Count = 0;
  dlstEID;
  dlstEID1;
  callsOption: string;
  approveOption;
  successfulData;
  TotalNumberOfCalls;
  approveCall;
  txtperiodfrom;
  txtperiodTo;
  AverageCost;
  selectedAll = false;
  TotalCharges;
  myMarkCall;
  maincount = 0;
  WBSEDetails;
  MyAuthCode;
  CountAll = 0;
  MarkList = [];
  filter;
  mainCountSingle = 0;
  prodata = [];
  ApproverList = [];
  RetriveData = [];
  AssignBSEDatas = [];
  EIDList = [];
  Facilities = [];
  WBSmarkCall;
  generateReport:any;

  // pager object
  pager: any = {};
  // array of all items to be paged
  private allItems: any[];
  // paged items
  pagedItems: any[];

  dataLoader = false;

  Eid5;
  staff;
  count;
  StaffName;
  Country;
  _Country;
  GDNGS;
  enterpriseid;
  CareerLevel;
  EmployeeNO;
  Encryptcallcharge;
  RoleReport;
  public SrcAlertForAccess = false;

  constructor(
    private capservice: CAPService,
    private pagerService: PagerService,
    private datePipe: DatePipe
  ) {
    this.Rundate = this.datePipe.transform(Date.now(), "yyyy-MM-dd hh:mm:ss a");

    this.Eid5 = this.capservice.enterpriseid;
    this.staff = this.capservice.DisplayName;
    this.count = this.capservice.country;
    this.StaffName = this.capservice.DisplayName;
    this.Country = this.capservice.country;
    this._Country = this.capservice.country;
    this.GDNGS = this.capservice.GDNGS;
    this.enterpriseid = this.capservice.enterpriseid;
    this.CareerLevel = this.capservice.CareerLevel;
    this.EmployeeNO = this.capservice.EmployeeNO;
    this.Encryptcallcharge = this.capservice.Encryptcallcharge;
    this.RoleReport = this.capservice.Role;
    (this.successfulData = {}),
      (this.successfulData.selected = {}),
      (this.WBSmarkCall = {}),
      (this.MyAuthCode = {}),
      (this.myMarkCall = {}),
      (this.approveCall = {}),
      (this.WBSEDetails = {});
  }

  ngOnInit() {
    this.dataLoader = true;
    this.GetWBS();
    this.WBSData();
    this.GetEid();
    this.getFacility();
    this.marlistvalues();
    this.reload();
    this.UpdatedWBSCode();
    this.getusecase();
    this.approverlistvalues();
    this.AudiLogin();
    this.dataLoader = false;
  }

  formatDateValue(date: Date) {
    const format = "yyyy-MM-dd";
    const locale = "en-US";
    const result = formatDate(date, format, locale);
    return result;
  }

  AudiLogin() {
    this.capservice
      .AudiLogin("Profile", this.enterpriseid)
      .subscribe((success) => {});
  }

  UpdatedWBSCode() {
    this.dataLoader = true;
    this.capservice
      .GetProfileDetails("N", this.EmployeeNO, "WBSDetails")
      .subscribe((data) => {
        if (data.length > 0) {
          this.AssignBSEDatas = data;
          this.dataLoader = false;
        }
      });
    this.dataLoader = false;
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.setDomLayout("autoHeight");
    this.gridColumnApi = params.columnApi;
  }

  approverlistvalues() {
    this.dataLoader = true;
    this.capservice.DropdownValues("ApproverList", "All").subscribe((data) => {
      this.ApproverList = data;
      this.dataLoader = false;
    });
    this.dataLoader = false;
  }

  showPicker(): void {
    this.PeriodFrom.open();
  }

  showPickerTo(): void {
    this.PeriodTo.open();
  }
  // exportToExcel(data){
  //   this.showReport=true;              
  //   console.log(this.generateReport)
  //   if(data.length > 0){    
  //    const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(data)     
  //    const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  //    XLSX.writeFile(wb, 'GenerateReports.xlsx');
  //   }
  //   else{
  //     this.showReport=false;
  //     alert('No data found to export');
  //   }
  // }
  exportToExcel(data) {
    this.showReport = true;
  
    if (data.length > 0) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sheet1');
      
      // Add header row
      const header = Object.keys(data[0]);
      worksheet.addRow(header);
  
      // Add data rows
      data.forEach(row => {
        const values = Object.values(row);
        worksheet.addRow(values);
      });
  
      // Save workbook
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const fileName = 'GenerateReports.xlsx';
        this.saveAs(blob, fileName);
      });
    } else {
      this.showReport = false;
      alert('No data found to export');
    }
  }
  
  saveAs(blob: Blob, fileName: string): void {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  }
  

  SetActiveTab(activeTabId) {
    this.dataLoader = true;
    $("#AlertForBusinessOnly").css("display", "none");
    $("#AlertPeriodExpired").css("display", "none");
    $('input[name="MarkCalls"]').prop("checked", false);
    $('input[name="MyMarkedCalls"]').prop("checked", false);
    $('input[name="ApproveCalls"]').prop("checked", false);
    $('input[name="MyApprovedCalls"]').prop("checked", false);
    $("#txtWBS1").val("");
    $("#txtWBS").val("");
    $("#dlstEID1").val("");
    $("#dlstEID").val("");
    $("#txtperiodfrom").val("");
    $("#txtperiodTo").val("");
    $("#divGenerateReport").css("display", "none");
    $("#divWBSEDetails").css("display", "block");
    this.IsShowMarkCalls = false;
    this.IsShowMyMarkCalls = false;
    this.IsShowApproveCalls = false;
    this.IsShowMyApprovedCalls = false;
    this.WBSData();
    this.reload();
    this.WBSEDetails.ProjectDescription = "";
    this.WBSEDetails.Facility = "";
    this.WBSEDetails.ChargeCode = "";
    this.ApproveCallsOptionWBS = "";
    this.ApproveCallsOptionWBS1 = "";
    this.dlstEID = "";
    this.dlstEID1 = "";
    this.txtperiodfrom = "";
    this.txtperiodTo = "";
    this.ActiveTab = activeTabId;
    this.dataLoader = false;
  }

  WBSData() {
    this.dataLoader = true;
    this.capservice
      .GetAuthcodeRequests("WBSE", this.EmployeeNO, "N")
      .subscribe((data) => {
        debugger;
        if (data.length > 0) {
          debugger;
          this.successfulData = { WBSEData: data, selected: {} };
          this.allItems = data;
          this.setPageWBS(1);
          $("#divWBSEDetails").css("display", "block");
          this.dataLoader = false;
        }
        this.dataLoader = false;
      });
    this.dataLoader = false;
  }

  IsTabActive(activeTabId) {
    return this.ActiveTab === activeTabId;
  }
  marlistvalues() {
    this.capservice.DropdownValues("MarkAsList", "All").subscribe((data) => {
      this.MarkList = data;
    });
  }
  closeWBSModal() {
    this.displayWBS = "none";
  }

  closeWBSMark() {
    this.displayWBSMark = "none";
  }

  SaveWBS() {
    this.dataLoader = true;
    this.capservice.WBSValidation(this.txtProfileWBS).subscribe((data: any) => {
      if (data == "False") {
        this.txtProfileWBS = "";
        alert("Please Enter valid WBS");
        this.dataLoader = false;
        return;
      } else {
        this.capservice
          .InsertProfileDetails(
            this.txtProfileWBS,
            this.enterpriseid,
            "SaveWBS"
          )
          .subscribe((data: any) => {
            if (data == "Inserted Successfully..") {
              this.displayWBS = "none";
              this.WBS = this.profile;
              this.dataLoader = false;
            }
            this.dataLoader = false;
          });
      }
    });
    this.dataLoader = false;
  }

  Cancel(Type) {
    this.dataLoader = true;
    if (Type == "MarkCall") {
      this.successfulData.markCalls.forEach((markCall) => {
        if (markCall.checked) {
          //this.showModalMarkCalls = !this.showModalMarkCalls;
          this.displayPopUp = "none";
          markCall.checked = false;
          this.selectedAll = false;
          this.dataLoader = false;
        }
        this.dataLoader = false;
      });

      this.dataLoader = false;
    } else if (Type == "ApproveCalls") {
      this.successfulData.selected.approvalStatus = "";
      this.successfulData.selected.approverEid = "";
      this.successfulData.selected.wbs = "";
      this.successfulData.selected.remarks = "";
      this.successfulData.approveCallsDetails.forEach((data) => {
        if (data.checked) {
          this.displayApproveCalls = "none";
          data.checked = false;
          this.selectedAll = false;
          this.dataLoader = false;
        }
      });
      this.dataLoader = false;
    } else if (Type == "WBS") {
      this.displayWBS = "none";
      this.dataLoader = false;
    } else if (Type == "MyMarkCall") {
      $("#divMark").modal("hide");
      this.dataLoader = false;
    } else if (Type == "MyApproveCalls") {
      //$('#divApprovecalls').modal('hide');
      this.displayApprovedCalls = "none";
      this.successfulData.selected.remarks = "";
      this.ShowData("ApprovedCallDetails");
      this.dataLoader = false;
    } else if (Type == "WBSCalls") {
      // this.successfulData.WBSmarkCallsData.forEach(WBSmarkCall => {
      //   if (WBSmarkCall.checked) {
      //    this.displayWBSMark="none";
      //     WBSmarkCall.checked = false;
      //     this.selectedAll = false;

      // }
      // });
      this.displayWBSMark = "none";
      this.dataLoader = false;
    }
    this.dataLoader = false;
  }

  // MarkAction() {
  //   this.filter = $('#MarkAs').val();
  //   switch (this.filter) {
  //       case "Personal": $('#divWBSElement').css("display", 'none');
  //           $('#divApprover').css("display", 'none');
  //           $('#divCostCenter').css("display", 'none');
  //           break;
  //       case "Business": $('#divWBSElement').css("display", 'block');
  //           $('#divApprover').css("display", 'block');
  //           $('#divCostCenter').css("display", 'block');
  //           break;
  //       case "For Verification": $('#divWBSElement').css("display", 'none');
  //           $('#divApprover').css("display", 'none');
  //           $('#divCostCenter').css("display", 'none');
  //           break;
  //   }
  // }

  MarkAction(callStatus) {
    switch (callStatus) {
      case "Personal":
        this.showWBSElement = false;
        this.showApprover = false;

        break;
      case "For Verification":
        this.showWBSElement = false;
        this.showApprover = false;

        break;
      case "Business":
        this.showWBSElement = true;
        this.showApprover = true;

        break;
      default:
        this.showWBSElement = true;
        this.showApprover = true;

        break;
    }
  }

  UpdateMyAuthCode(idx) {
    this.dataLoader = true;
    let message = "";

    if ($("#grdmanagerEid").val() == "") {
      message = "Please Enter Supervisor Id ";
      this.dataLoader = false;
    }
    if ($("#grdwbsElement").val() == "") {
      message = message + "\n" + "Please Enter WBSE ";
      this.dataLoader = false;
    }
    // if ($('#grdwbsElement').val() != '') {
    //     if (validateAlpaNumeric('grdwbsElement')) { }
    //     else { message = message + "\n" + "Please Enter Valid WBS"; }
    // }

    // function validateAlpaNumeric(txtPhone) {
    //   var a = $("#txtPhone").val();
    //   var filter = /^$|^[A-Za-z0-9]+$/;
    //   if (filter.test(a)) { return true; }
    //   else { return false; }
    // }

    if (message != "") {
      alert(message);
      this.dataLoader = false;
    } else {
      this.successfulData.MyAuthCodeData[idx] = Object.assign(
        {},
        this.successfulData.selected
      );
      this.successfulData.selected.strType = "ProfileAuthCode";
      this.successfulData.selected.managerEid = $("#grdmanagerEid").val();
      this.successfulData.selected.wbsElement = $("#grdwbsElement").val();
      this.successfulData.selected.eid = $("#grdUserId").val();
      // console.log(this.successfulData.selected);
      //this.successfulData.selected.token = MYCASService.tokenManager();

      this.capservice
        .UpdateAuthCodeDetails(this.successfulData.selected)
        .subscribe((data: any) => {
          if (data == "Updated Successfully..") {
            //alert(data);
            this.reload();
            this.dataLoader = false;
          } else if (data == "Update Failed..") {
            alert("Updation Failed");
            this.reload();
            this.dataLoader = false;
          } else if (data == "Already Exists") {
            alert("Data Already Exists");
            this.reload();
            this.dataLoader = false;
          } else {
            alert(data);
            this.reload();
            this.dataLoader = false;
          }
        });
      this.dataLoader = false;
    }
    this.dataLoader = false;
  }

  reload() {
    this.dataLoader = true;
    this.capservice
      .GetProfileDetails(this.Country, this.enterpriseid, "MyAuthCode")
      .subscribe((data) => {
        if (data.length > 0) {
          this.successfulData = { MyAuthCodeData: data, selected: {} };
          this.allItems = data;
          this.setPageauth(1);
          // $('#AlertForAccess').css('display', 'none');
          $("#divMyAuthCode").css("display", "block");

          this.SrcAlertForAccess = false;
          this.dataLoader = false;
        } else {
          debugger;
          // $('#AlertForAccess').css('display','block');
          this.SrcAlertForAccess = true;
          this.dataLoader = false;
        }
        this.dataLoader = false;
      });
    this.dataLoader = false;
  }

  reset() {
    $("#thnewwbs").css("display", "none");
    this.successfulData.selected = {};
  }

  getFacility() {
    this.capservice.FacilityList(this.Country).subscribe((data) => {
      this.Facilities = data;
    });
  }

  EditMyAuthCode(MyAuthCode) {
    this.successfulData.selected = Object.assign({}, MyAuthCode);
  }
  EditAuthCodeUpdateWBSE(MyAuthCode) {
    $("#thnewwbs").css("display", "block");
    this.successfulData.selected = Object.assign({}, MyAuthCode);
  }
  UpdateAuthCodeUpdateWBSE(MyAuthCode) {
    debugger;
    this.dataLoader = true;
    let message = "";
    if (this.successfulData.selected.managerEid == "") {
      message = "Please Enter Supervisor ID";
      this.dataLoader = false;
    }
    if (
      this.successfulData.selected.NewWBSE == "" ||
      this.successfulData.selected.NewWBSE == null
    ) {
      message = message + "\n" + "Please Enter New WBSE";
      this.dataLoader = false;
    }
    if (message != "") {
      alert(message);
      this.dataLoader = false;
    } else {
      this.successfulData.selected.strType = "AuthCodeUpdateWBSE";
      this.successfulData.selected.authCodeId =
        (this.successfulData.selected.authCodeId! = null)
          ? this.successfulData.selected.authCodeId.toString()
          : "";
      this.successfulData.selected.Add_ApproverID = "";
      this.successfulData.selected.CeilCode = "";
      this.successfulData.selected.ChangeAuthcode = "";
      this.successfulData.selected.IsWbsValid = "";
      this.successfulData.selected.OfficeId = "";
      //this.successfulData.selected.ToDate =this.successfulData.selected.FromDate;
      this.successfulData.selected.ToDate = this.successfulData.selected.ToDate;
      this.successfulData.selected.FromDate =
        this.successfulData.selected.FromDate;
      this.successfulData.selected.UserId = "";
      this.successfulData.selected.comments = "";
      this.successfulData.selected.expiry = "";
      this.successfulData.selected.extension = "";
      this.successfulData.selected.sapId = "";
      this.successfulData.selected.userType = "";

      this.capservice
        .UpdateAuthCodeDetails(this.successfulData.selected)
        .subscribe((data: any) => {
          if (data == "Updated Successfully") {
            alert("Updated Successfully");
            this.reload();
            $("#thnewwbs").css("display", "none");
            this.dataLoader = false;
          } else if (data == "Update Failed") {
            alert("Updated Failed");
            this.reload();
            $("#thnewwbs").css("display", "none");
            this.dataLoader = false;
          } else {
            alert(data);
            // this.reload();
            // $('#thnewwbs').css("display", 'none');
            this.dataLoader = false;
          }
        });
    }
  }

  AddWBSE() {
    this.dataLoader = true;
    let message = "";
    if ($("#grdfWBSE").val() == "") {
      message = "Please Enter WBSE";
      this.dataLoader = false;
    }
    if ($("#grdfFacility").val() == "") {
      message = message + "\n" + "Please Select Facility";
      this.dataLoader = false;
    }
    if ($("#grdfProjectDescription").val() == "") {
      message = message + "\n" + "Please Select Project Information";
      this.dataLoader = false;
    }
    if (message != "") {
      alert(message);
      this.dataLoader = false;
    } else {
      this.WBSEDetails.EmployeeNO = this.EmployeeNO;
      this.WBSEDetails.EnterpriseID = this.enterpriseid;
      this.capservice
        .InsertWBSEDetails(this.WBSEDetails, "Insert")
        .subscribe((data: any) => {
          if (data == "Please Enter valid WBS") {
            alert(data);
            $("#grdfWBSE").val("");
            this.dataLoader = false;
          } else if (data) {
            alert("Inserted Successfully");
            this.dataLoader = false;
            this.capservice
              .GetAuthcodeRequests("WBSE", this.EmployeeNO, "N")
              .subscribe((data) => {
                if (data.length > 0) {
                  this.successfulData = { WBSEData: data, selected: {} };
                  this.allItems = data;
                  this.setPageWBS(1);
                  $("#divWBSEDetails").css("display", "block");
                  this.dataLoader = false;
                }
                this.dataLoader = false;
              });
            this.clear();
            this.dataLoader = false;
          }
        });
      this.dataLoader = false;
    }
    this.dataLoader = false;
  }

  clear() {
    $("#grdfWBSE").val("");
    $("#grdfFacility").val("");
    $("#grdfProjectDescription").val("");
  }

  GetEid() {
    this.dataLoader = true;
    this.capservice
      .GetProfileDetails("N", this.enterpriseid, "ViewApprovedCallsByEid")
      .subscribe((data) => {
        this.EIDList = data;
        this.dataLoader = false;
      });
    this.dataLoader = false;
  }

  GetWBS() {
    this.dataLoader = true;
    this.capservice
      .GetProfileDetails(this.count, this.enterpriseid, "ProfileEid")
      .subscribe((data) => {
        if (data.length > 0) {
          this.profile = data[0].WBS;
          //alert(this.profile);
          this.WBS = this.profile;
          this.dataLoader = false;
        } else {
          this.WBS = "";
          this.dataLoader = false;
        }
        this.dataLoader = false;
      });
    this.dataLoader = false;
  }

  getusecase() {
    this.dataLoader = true;
    this.capservice
      .GetProfileDetails(this.Country, this.GDNGS, "UseCase")
      .subscribe((data) => {
        this.usecase = data[0].UseCase;

        //console.log(this.usecase);
        if (this.usecase == "Billing") {
          this.IsShowProfileActive = true;
          this.IsMyAuthcodeActive = true;
          this.IsShowWBSEActive = false;
          this.dataLoader = false;
          if (this.day >= 10 && this.day <= 13) {
            this.IsShowMarkActive = true;
            $("#AlertForBusinessOnly").css("display", "none");
            $("#AlertPeriodExpired").css("display", "none");
            this.dataLoader = false;
          } else {
            this.IsShowMarkActive = false;

            $("#AlertForBusinessOnly").css("display", "none");
            $("#AlertPeriodExpired").css("display", "block");
            this.dataLoader = false;
          }
          if (this.day >= 10 && this.day <= 13) {
            this.IsShowApproveActive = true;
            $("#AlertForBusinessOnly").css("display", "none");
            $("#AlertPeriodExpired").css("display", "none");
            this.dataLoader = false;
          } else {
            this.IsShowApproveActive = false;

            $("#AlertForBusinessOnly").css("display", "block");
            $("#AlertPeriodExpired").css("display", "none");
            this.dataLoader = false;
          }
          this.IsShowReportActive = true;
          this.capservice
            .GetProfileDetails(this.Country, this.enterpriseid, "ProfileEid")
            .subscribe((data) => {
              if (this.profile == "" || data.length == 0) {
                this.capservice
                  .InsertProfileDetails(
                    this.Country,
                    this.enterpriseid,
                    "UserProfile"
                  )
                  .subscribe((data) => {
                    this.displayWBS = "none";
                    this.dataLoader = false;
                  });
                this.dataLoader = false;
              }
              this.profile = data[0].WBS;
              //alert(data[0].WBS);
              //}
              this.WBS = this.profile;
              //console.log(this.WBS);
              this.dataLoader = false;
            });
          this.dataLoader = false;
        } else if (this.usecase == "Reporting") {
          this.displayWBS = "none";
          this.IsShowProfileActive = true;
          this.IsShowMarkActive = false;
          this.IsShowApproveActive = false;
          this.IsShowReportActive = true;
          this.IsShowWBSEActive = false;
          this.IsMyAuthcodeActive = true;
          this.dataLoader = false;
        } else {
          this.displayWBS = "none";
          this.IsShowProfileActive = true;
          this.IsMyAuthcodeActive = true;

          if (this.day >= 7 && this.day <= 13) {
            this.IsShowMarkActive = true;
            $("#AlertForBusinessOnly").css("display", "none");
            $("#AlertPeriodExpired").css("display", "none");
            this.dataLoader = false;
          } else {
            this.IsShowMarkActive = false;

            $("#AlertForBusinessOnly").css("display", "none");
            $("#AlertPeriodExpired").css("display", "block");
            this.dataLoader = false;
          }
          this.IsShowApproveActive = false;
          this.IsShowReportActive = true;
          this.dataLoader = false;
        }
        this.dataLoader = false;
      });
    this.dataLoader = false;
  }

  SelectWBSEData() {
    //console.log("WBSE called")
    //
    this.dataLoader = true;
    this.displayWBSMark = "block";
    let i = 0;
    // console.log(this.successfulData.WBSmarkCallsData);
    this.successfulData.WBSmarkCallsData.forEach((WBSmarkCall) => {
      if (WBSmarkCall.checked) {
        i++;
        this.capservice
          .GetProfileDetails("N", this.EmployeeNO, "WBSDetails")
          .subscribe((data) => {
            if (data.length > 0) {
              this.AssignBSEDatas = data;
              this.allItems = data;
              this.setPages(1);
              this.dataLoader = false;
            }
            this.dataLoader = false;
          });
        this.dataLoader = false;
      }
      this.dataLoader = false;
    });
    this.dataLoader = false;
    if (i == 0) {
      alert("Please Select Atleast One Record");
      this.displayWBSMark = "none";
      this.dataLoader = false;
    }
    this.dataLoader = false;
  }

  popup(Status) {
    this.dataLoader = true;
    if (this.Count == this.mainCountSingle) {
      if (Status == "Submit") {
        alert("Updated successfully");
        this.dataLoader = false;
      }
      if (Status == "WBSSubmit") {
        this.capservice
          .GetProfileDetails("N", this.enterpriseid, "WBSMarkCallDetails")
          .subscribe((data) => {
            if (data.length > 0) {
              this.successfulData = { WBSmarkCallsData: data, selected: {} };
              this.dataLoader = false;
            }
            this.dataLoader = false;
          });
        this.dataLoader = false;
        this.successfulData.WBSmarkCallsData.forEach((WBSmarkCall) => {
          if (WBSmarkCall.checked) {
            WBSmarkCall.checked = false;
            this.dataLoader = false;
          }
          this.dataLoader = false;
        });
        this.dataLoader = false;
        alert("Updated successfully");
        this.dataLoader = false;
      }
      this.dataLoader = false;
      if (Status == "WBS") {
        alert("Please Enter valid WBS");
        this.dataLoader = false;
      }
      if (Status == "Approver") {
        alert(
          "Please Enter valid Enterprise ID and Approver should be Level D or Above"
        );
        this.dataLoader = false;
      }
      $("#waitImg").css("display", "none");
      $("#waitApproverImg").css("display", "none");
      this.dataLoader = false;
    } else if (this.CountAll == this.maincount) {
      if (Status == "Submit") {
        alert("Updated successfully");
        this.selectedAll = false;
        this.dataLoader = false;
      }
      if (Status == "WBSSubmit") {
        this.successfulData.WBSmarkCallsData.forEach((WBSmarkCall) => {
          if (WBSmarkCall.checked) {
            this.selectedAll = false;
            this.dataLoader = false;
          }
          this.dataLoader = false;
        });
        this.capservice
          .GetProfileDetails("N", this.enterpriseid, "WBSMarkCallDetails")
          .subscribe((data) => {
            if (data.length > 0) {
              this.successfulData = { WBSmarkCallsData: data, selected: {} };
              this.dataLoader = false;
            }
            this.dataLoader = false;
          });
        alert("Updated successfully");
        this.dataLoader = false;
      }
      if (Status == "WBS") {
        alert("Please Enter valid WBS");
        this.dataLoader = false;
      }
      if (Status == "Approver") {
        alert(
          "Please Enter valid Enterprise ID and Approver should be Level D or Above"
        );
        this.dataLoader = false;
      }
      $("#waitImg").css("display", "none");
      $("#waitApproverImg").css("display", "none");
      this.dataLoader = false;
    }
    this.dataLoader = false;
  }

  selectionApproveClick(type) {
    //console.log(type);
    this.dataLoader = true;
    //this.usecase="Billing";
    if (type == "ApproveCalls") {
      this.ApproveCallsOptionWBS1 = "";
      this.dlstEID1 = "";
      if (this.usecase == "Billing") {
        this.IsShowMarkCalls = false;
        this.IsShowMyMarkCalls = false;
        this.IsShowApproveCalls = true;
        this.IsShowMyApprovedCalls = false;
        this.IsShowWBSEActive = false;

        this.ShowData("ApproveCallsDetails");
        this.dataLoader = false;

        // $('#displayTblApproveCallsDetails').css("display", 'block');
      }
      this.dataLoader = false;
    } else if (type == "MyApprovedCalls") {
      this.ApproveCallsOptionWBS = "";
      this.dlstEID = "";
      if (this.usecase == "Billing") {
        this.IsShowMarkCalls = false;
        this.IsShowMyMarkCalls = false;
        this.IsShowApproveCalls = false;
        this.IsShowMyApprovedCalls = true;
        this.IsShowWBSEActive = false;
        this.ShowData("ApprovedCallDetails");
        this.dataLoader = false;
        // $('#divMyApproveCallDetails').css("display", 'block');
      }
      this.dataLoader = false;
    }
    this.dataLoader = false;
  }

  WBSMarkCallSubmitData() {
    //
    this.dataLoader = true;
    let i = 0;
    this.Count = 0;
    this.maincount = 0;
    this.mainCountSingle = 0;
    this.CountAll = 1;
    this.successfulData.WBSmarkCallsData.forEach((WBSmarkCall) => {
      if ($("input:checkbox:checked").length > 1) {
        this.maincount = this.successfulData.WBSmarkCallsData.length;
        this.dataLoader = false;
      } else {
        this.mainCountSingle = $("input:checkbox:checked").length;
        this.dataLoader = false;
      }
      if (WBSmarkCall.checked) {
        i++;
        this.capservice
          .AuthCodeDetails(
            WBSmarkCall.cdrId,
            WBSmarkCall.wbs,
            "WBSMarkCallUpdate",
            "NULL",
            "NULL",
            "NULL",
            "NULL"
          )
          .subscribe((data) => {
            if (data) {
              this.Count++;
              this.CountAll++;
              this.popup("WBSSubmit");
              this.dataLoader = false;
              //alert("Updated successfully");
            }
            this.dataLoader = false;
          });
        this.dataLoader = false;
      }
      this.dataLoader = false;
    });
    this.dataLoader = false;
    if (i == 0) {
      alert("Please Select Atleast One Record");
      this.dataLoader = false;
    }
    this.dataLoader = false;
  }

  ShowData(type,btntype='search') {
    this.dataLoader = true;
    let i = 0;

    if (type == "MarkCallDetails") {
      this.capservice
        .GetProfileDetails("N", this.enterpriseid, type)
        .subscribe((data) => {
          if (data.length > 0) {
            this.successfulData = { markCalls: data, selected: {} };
            this.allItems = data;
            this.setPage(1);
            $("#divMarkCallDetails").css("display", "block");
            $("#divWBSEDetails").css("display", "none");
            this.dataLoader = false;
          } else {
            $("#divMarkCallDetails").css("display", "none");
            $("#divWBSEDetails").css("display", "none");
            this.dataLoader = false;
          }
          this.TotalNumberOfCalls = data.length;
          this.dataLoader = false;
          if (data.length > 0) {
            this.successfulData.markCalls.forEach((markCall) => {
              i += markCall.callCost;
              this.dataLoader = false;
            });
            this.TotalCharges = i;
            this.AverageCost = this.TotalCharges / this.TotalNumberOfCalls;
            this.dataLoader = false;
          } else {
            this.TotalCharges = "0";
            this.AverageCost = "0";
            this.dataLoader = false;
          }
          this.dataLoader = false;
        });
      this.dataLoader = false;
    } else if (type == "MarkedCallDetails") {
      this.capservice
        .GetProfileDetails("N", this.enterpriseid, "CountofMarkedCallDetails")
        .subscribe((data) => {
          if (data.length > 0) {
            this.myMarkCall = { myMarkCallsDetails: data, selected: {} };
            $("#tblMyMarkCallsDetails").css("display", "block");
            this.dataLoader = false;
            // this.allItems=data;
            // this.setPagetwo(1);
          }
          this.dataLoader = false;
        });
      this.capservice
        .GetProfileDetails("N", this.enterpriseid, type)
        .subscribe((data) => {
          if (data.length > 0) {
            this.successfulData = { myMarkCalls: data, selected: {} };
            this.allItems = data;
            this.setPagetwo(1);
            $("#divMyMarkCallDetails").css("display", "block");
            this.dataLoader = false;
          } else {
            $("#divMyMarkCallDetails").css("display", "none");
            this.dataLoader = false;
          }
          this.dataLoader = false;
        });
      this.dataLoader = false;
    } else if (type == "ApproveCallsDetails") {
      this.capservice
        .GetProfileDetails("N", this.enterpriseid, "CountofApproveCallDetails")
        .subscribe((data) => {
          if (data.length > 0) {
            this.approveCall = {
              approveCallsDetailedDetails: data,
              selected: {},
            };
            $("#tblApproveCallsDetails").css("display", "block");
            this.dataLoader = false;
          }
          this.dataLoader = false;
        });
      this.capservice
        .GetProfileDetails("N", this.enterpriseid, type)
        .subscribe((data) => {
          if (data.length > 0) {
            this.successfulData = { approveCallsDetails: data, selected: {} };
            this.allItems = data;
            this.setPageappcalls(1);
            $("#divApproveCallDetails").css("display", "block");
            this.dataLoader = false;
          } else {
            $("#divApproveCallDetails").css("display", "none");
            this.dataLoader = false;
          }
          this.dataLoader = false;
        });
      this.dataLoader = false;
    } else if (type == "SearchApproveDetails") {
      var WBS = $("#txtWBS").val() == "" ? "N" : $("#txtWBS").val();
      var EID = $("#dlstEID").val() == "" ? "N" : $("#dlstEID").val();
      this.capservice
        .SearchDetails(
          WBS,
          EID,
          this.enterpriseid,
          "N",
          "ApproveCallsSearchDetails"
        )
        .subscribe((data) => {
          if (data.length > 0) {
            this.successfulData = { approveCallsDetails: data, selected: {} };
            //console.log(this.successfulData.approveCallsDetails);
            this.allItems = data;
            this.setPageappcalls(1);
            $("#divApproveCallDetails").css("display", "block");
            this.dataLoader = false;
          } else {
            alert("No Records found");

            $("#divApproveCallDetails").css("display", "none");
            this.dataLoader = false;
          }
          this.dataLoader = false;
        });
      this.dataLoader = false;
    } else if (type == "ApprovedCallDetails") {
      this.capservice
        .GetProfileDetails("N", this.enterpriseid, type)
        .subscribe((data) => {
          if (data.length > 0) {
            this.successfulData = { myApproveCallsDetails: data, selected: {} };
            this.allItems = data;
            this.setPagemyappcalls(1);
            $("#divMyApproveCallDetails").css("display", "block");
            this.dataLoader = false;
          } else {
            $("#divMyApproveCallDetails").css("display", "none");
            this.dataLoader = false;
          }
          this.dataLoader = false;
        });
      this.dataLoader = false;
    } else if (type == "SearchMyApproveDetails") {
      var WBS = $("#txtWBS1").val() == "" ? "N" : $("#txtWBS1").val();
      var EID = $("#dlstEID1").val() == "" ? "N" : $("#dlstEID1").val();
      this.capservice
        .SearchDetails(
          WBS,
          EID,
          this.enterpriseid,
          "N",
          "MyApproveCallsSearchDetails"
        )
        .subscribe((data) => {
          if (data.length > 0) {
            this.successfulData = { myApproveCallsDetails: data, selected: {} };
            this.allItems = data;
            this.setPagemyappcalls(1);
            $("#divMyApproveCallDetails").css("display", "block");
            this.dataLoader = false;
          } else {
            alert("No Records found");
            $("#divMyApproveCallDetails").css("display", "none");
            this.dataLoader = false;
          }
          this.dataLoader = false;
        });
      this.dataLoader = false;
    } else if (type == "GenerateReportDetails") {
      let message = "";
      if ($("#txtperiodfrom").val() == "") {
        message = message + "\n" + "Please Select Start Date";
        this.dataLoader = false;
      }
      if ($("#txtperiodTo").val() == "") {
        message = message + "\n" + "Please Select End Date";
        this.dataLoader = false;
      }

      if (message != "") {
        alert(message);this.showReport=false;
        this.dataLoader = false;
      } else {
        this.capservice
        .SearchDetailreportgerate(
          
          this.formatDateValue($("#txtperiodfrom").val()),
          this.formatDateValue($("#txtperiodTo").val()),
            this.enterpriseid,
            "GenerateReport"
          )
          .subscribe((data) => {
            if (data.length > 0) {
              this.showReport=true;
              this.generateReport=data;             
              if(btntype==='export') this.exportToExcel(data);
              
            } else {
              alert("No Records found");
              this.showReport=false;
              this.dataLoader = false;
            }
          });
      }
    }
    else if (type == "ExportReportDetails") {
      let message = "";
      if ($("#txtperiodfrom").val() == "") {
        message = message + "\n" + "Please Select Start Date";
        this.dataLoader = false;
      }
      if ($("#txtperiodTo").val() == "") {
        message = message + "\n" + "Please Select End Date";
        this.dataLoader = false;
      }

      if (message != "") {
        alert(message);
        this.dataLoader = false;
      } else {
        this.capservice
          .ExportDetails(
            this.enterpriseid,
            $("#txtperiodfrom").val(),
            $("#txtperiodTo").val(),
            "N",
            "CallCharge"
          )
          .subscribe(
            (data: Blob) => {
              console.log(data);
              const ReportName = 'GenerateReport' + ".xlsx";
              if (data!=null) {
                if (
                  window.navigator &&
                  (window.navigator as any).msSaveOrOpenBlob
                ) {
                  // for IE
                  (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
                  
                } else {
                  const link = document.createElement("a");
                  link.href = window.URL.createObjectURL(data);
                  link.download = ReportName;
                  link.click();
                }
            
                alert("No Records Found");
                
              }
            },
            function (x) {
              console.log(x);
              alert("Acknowledgement failed");
              this.loaderGif = false;
            }
          );
      }
    }
    if (type == "WBSMarkCallDetails") {
      this.capservice
        .GetProfileDetails("N", this.enterpriseid, "WBSMarkCallDetails")
        .subscribe((data) => {
          if (data.length > 0) {
            this.successfulData = { WBSmarkCallsData: data, selected: {} };
            this.allItems = data;
            this.setPageone(1);
            $("#divMarkCallDetails").css("display", "none");
            $("#divWBSMarkCallDetails").css("display", "block");
            $("#WBSMarkCallSubmit").css("display", "block");
            this.dataLoader = false;
          } else {
            $("#divMarkCallDetails").css("display", "none");
            $("#divWBSMarkCallDetails").css("display", "none");
            $("#WBSMarkCallSubmit").css("display", "none");
            this.dataLoader = false;
          }
          //  this.getWBSmarkCallTemplate = function (WBSmarkCall) {
          //   return 'WBSdisplay';
          //    };
          this.TotalNumberOfCalls = data.length;
          if (data.length > 0) {
            this.successfulData.WBSmarkCallsData.forEach((WBSmarkCall) => {
              i += WBSmarkCall.callCost;
              this.dataLoader = false;
            });
            this.TotalCharges = i;
            this.AverageCost = this.TotalCharges / this.TotalNumberOfCalls;
            this.dataLoader = false;
          } else {
            this.TotalCharges = "0";
            this.AverageCost = "0";
            this.dataLoader = false;
          }
        });
    }
    this.dataLoader = false;
  }

  checkAll(ischecked, type) {
    this.dataLoader = true;
    if (type == "MarkCalls") {
      this.successfulData.selected.Type = "MarkCall";
      this.successfulData.markCalls.forEach((markCall) => {
        if (ischecked) {
          markCall.checked = true;
          this.displayPopUp = "block";
          this.dataLoader = false;
        } else {
          markCall.checked = false;
          this.displayPopUp = "none";
          this.dataLoader = false;
        }
        this.dataLoader = false;
      });
      this.dataLoader = false;
    } else if (type == "WBSMarkCalls") {
      this.IsShowMarkCalls = true;
      this.successfulData.WBSmarkCallsData.forEach((WBSmarkCall) => {
        if (ischecked) {
          WBSmarkCall.checked = true;
          this.dataLoader = false;
        } else {
          WBSmarkCall.checked = false;
          this.dataLoader = false;
        }
        this.dataLoader = false;
      });
      this.dataLoader = false;
    } else {
      // this.capservice.DropdownValues("ApproverList", "All").subscribe(data => {
      //   this.ApproverList = data;

      // });
      this.successfulData.approveCallsDetails.forEach((data) => {
        if (ischecked) {
          data.checked = true;
          this.selectedAll = true;
          this.displayApproveCalls = "block";
          this.dataLoader = false;
        } else {
          data.checked = false;
          this.selectedAll = false;
          this.displayApproveCalls = "none";
          this.dataLoader = false;
        }
        this.dataLoader = false;
      });
      this.selectedAll = false;
      this.dataLoader = false;
      // this.selectedAll=false;
    }
    this.dataLoader = false;
  }

  ApproveCallsAdd() {
    this.dataLoader = true;
    let message = "";
    // this.capservice.DropdownValues("ApproverList", "All").subscribe(data => {
    //   this.ApproverList = data;

    // });
    if (
      this.successfulData.selected.approvalStatus == "" ||
      this.successfulData.selected.approvalStatus == null ||
      this.successfulData.selected.approvalStatus == undefined
    ) {
      message = "Please select Action";
      this.dataLoader = false;
    }
    if (
      this.successfulData.selected.remarks == "" ||
      this.successfulData.selected.remarks == null ||
      this.successfulData.selected.remarks == undefined
    ) {
      message = message + "\n" + "Please Enter Remarks";
      this.dataLoader = false;
    }
    if (this.successfulData.selected.approvalStatus == "Transfer Approver") {
      if (
        this.successfulData.selected.approverEid == "" ||
        this.successfulData.selected.approverEid == null ||
        this.successfulData.selected.approverEid == undefined
      ) {
        message = message + "\n" + "Please Enter Approver";
        this.dataLoader = false;
      }
      this.dataLoader = false;
    }
    if (this.successfulData.selected.approvalStatus == "Change WBS") {
      if (
        this.successfulData.selected.wbs == "" ||
        this.successfulData.selected.wbs == null ||
        this.successfulData.selected.wbs == undefined
      ) {
        message = message + "\n" + "Please Enter WBS";
        this.dataLoader = false;
      }
      this.dataLoader = false;
    }
    if (message != "") {
      alert(message);
      this.dataLoader = false;
    } else if (this.successfulData.selected.AType != "MyApproveCall") {
      this.successfulData.approveCallsDetails.forEach((data) => {
        this.maincount = 0;
        this.mainCountSingle = 0;
        this.Count = 0;
        this.CountAll = 1;
        if ($("input:checkbox:checked").length > 1) {
          this.maincount = this.successfulData.approveCallsDetails.length;
          this.dataLoader = false;
        } else {
          this.mainCountSingle = $("input:checkbox:checked").length;
          this.dataLoader = false;
        }
        if (data.checked) {
          //console.log(this.successfulData.selected);
          this.capservice
            .InsertProfileOtherDetails(
              this.successfulData.selected,
              "ApproveCallDetails",
              this.enterpriseid,
              "N",
              data.cdrId
            )
            .subscribe((data: any) => {
              if (data == "Please Enter valid WBS") {
                //alert(data);
                $("#Wbs").val("");
                this.Count++;
                this.CountAll++;
                this.popup("WBS");
                this.dataLoader = false;
              }
              if (
                data == "Please Enter valid Enterprise ID" ||
                data == "Approver should be Level D and Above"
              ) {
                //alert(data);
                this.Count++;
                this.CountAll++;
                $("#Approver").val("");
                this.popup("Approver");
                this.dataLoader = false;
              }
              if (data == "Success") {
                // alert("Updated successfully");
                //   this.selectedAll=false;
                //   this.displayApproveCalls="none";
                //  this.displayApprovedCalls="none";

                this.Count++;
                this.CountAll++;
                this.ShowData("ApproveCallsDetails");

                this.popup("Submit");
                //this.ShowData('ApproveCallsDetails');
                //this.selectedAll=false;

                this.displayApproveCalls = "none";
                data.checked = false;
                this.selectedAll = false;
                this.dataLoader = false;
              }
              this.dataLoader = false;
            });
          this.dataLoader = false;
        }
        this.dataLoader = false;
      });
      this.selectedAll = this.selectedAll;
      this.dataLoader = false;
    } else {
      this.capservice
        .InsertProfileOtherDetails(
          this.successfulData.selected,
          "ApproveCallDetails",
          this.enterpriseid,
          "N",
          this.successfulData.selected.cdrId
        )
        .subscribe((data: any) => {
          if (data == "Please Enter valid WBS") {
            this.successfulData.selected.wbs = "";
            alert(data);
            this.dataLoader = false;
            return;
          }
          if (data == "Approver should be Level D and Above") {
            this.successfulData.selected.approverEid = "";
            alert(data);

            this.dataLoader = false;
            return;
          }
          if (data == "Success") {
            this.ShowData("MyApproveCallsDetails");
            alert("Updated successfully");
            this.displayApproveCalls = "none";
            this.displayApprovedCalls = "none";
            this.dataLoader = false;
          }
          this.dataLoader = false;
        });
      this.dataLoader = false;
    }
    this.dataLoader = false;
  }

  Onclick(sel, Type) {
    if (Type == "MarkCall") {
      this.displayPopUp = "block";
      $("#btnMarkCancel").css("display", "block");
      $("#btnEditMarkCancel").css("display", "none");
      this.successfulData.selected.Type = Type;
      this.successfulData.markCalls.forEach((markCall) => {
        if (sel) {
          if (markCall.checked) {
            //console.log(markCall.checked);
            this.selectedAll = false;
            this.displayPopUp = "none";
            //this.showModalMarkCalls!=this.showModalMarkCalls;
          } else {
            this.selectedAll = true;
            this.displayPopUp = "block";
          }
        }
      });
    }
  }

  PreviewClick(Calls, Type) {
    this.dataLoader = true;
    this.selectedAll = false;
    if (Type == "MyMarkCall") {
      $("#btnMarkCancel").css("display", "none");
      this.successfulData.selected.callStatus = "";
      $("#divWBSElement").val("");
      $("#divApprover").val("");
      $("#Remarks").val("");
      $("#btnEditMarkCancel").css("display", "block");

      this.successfulData.selected = Calls;

      // console.log(this.successfulData.selected);
      this.successfulData.selected.Type = Type;
      this.dataLoader = false;
      if (
        this.successfulData.selected.callStatus == "Personal" ||
        this.successfulData.selected.callStatus == "For Verification"
      ) {
        this.divWBSElement = "none";
        this.divApprover = "none";

        $("#divWBSElement").val("");
        $("#divApprover").val("");
        this.dataLoader = false;
      } else if (this.successfulData.selected.callStatus == "Business") {
        this.divWBSElement = "block";
        this.divApprover = "block";
        this.dataLoader = false;
      }
      //this.showModalMarkCalls!=this.showModalMarkCalls;
      this.displayPopUp = "block";
      this.dataLoader = false;
    } else if (Type == "MyApproveCall") {
      this.successfulData.selected = Calls;
      this.successfulData.selected.AType = Type;
      // $("#ActionAs option[value='Transfer Approver']").remove();
      //       $("#ActionAs option[value='Reject']").remove();
      //$('#btnApprovecancel').css("display", 'none');
      this.btnApprovecancel = "none";
      //$('#btnEditApprovecancel').css("display", 'block');
      this.btnEditApprovecancel = "block";
      this.displayApprovedCalls = "block";
      this.dataLoader = false;
      if (this.successfulData.selected.approvalStatus == "Change WBS") {
        $("#divappWBS").css("display", "block");
        this.dataLoader = false;
      } else {
        $("#divappWBS").css("display", "none");
        this.dataLoader = false;
      }
      this.dataLoader = false;
    } else if (Type == "MarkCall") {
      this.displayPopUp = "block";
      $("#btnMarkCancel").css("display", "block");
      $("#btnEditMarkCancel").css("display", "none");
      this.successfulData.selected.Type = Type;
      this.successfulData.markCalls.forEach((markCall) => {
        if (markCall.checked == undefined || markCall.checked) {
          //console.log(markCall.checked);
          this.selectedAll = true;
          this.displayPopUp = "block";
          this.dataLoader = false;
          //this.showModalMarkCalls!=this.showModalMarkCalls;
        }
        this.dataLoader = false;
      });
      this.selectedAll = false;
      this.dataLoader = false;
    } else if (Type == "ApproveCalls") {
      this.displayApproveCalls = "block";
      // this.capservice.DropdownValues("ApproverList","All").subscribe(data=>{
      //   this.ApproverList=data;

      // });

      //$('#btnApprovecancel').css("display", 'block');
      //$('#btnEditApprovecancel').css("display", 'none');
      this.btnApprovecancel = "block";
      this.btnEditApprovecancel = "none";
      this.successfulData.approveCallsDetails.forEach((data) => {
        if (data.checked == undefined || data.checked) {
          this.selectedAll = true;

          this.displayApproveCalls = "block";
          this.dataLoader = false;
        }
        this.dataLoader = false;
      });
      this.selectedAll = false;
      this.dataLoader = false;
    } else if (Type == "WBSmarkCallChecked") {
      const WBSmarkCall1 = "";

      this.successfulData.WBSmarkCallsData.forEach((WBSmarkCall) => {
        WBSmarkCall.checked = true;
        if (WBSmarkCall.checked) {
          if (WBSmarkCall.wbs == "") {
            this.capservice
              .GetProfileDetails("N", this.EmployeeNO, "WBSDetails")
              .subscribe((data) => {
                if (data.length > 0) {
                  this.AssignBSEDatas = data;
                  this.displayWBSMark = "block";
                  this.dataLoader = false;
                } else {
                  this.displayWBSMark = "block";
                  WBSmarkCall.wbs = "";
                  WBSmarkCall.checked = false;
                  this.dataLoader = false;
                }
                this.dataLoader = false;
              });
            this.dataLoader = false;
          }
          this.dataLoader = false;
        }
        this.dataLoader = false;
      });
      this.dataLoader = false;
    }
    this.dataLoader = false;
  }

  PreviewWBSClick(Calls, Type, AssignBSEData) {
    if (Type == "WBSmarkCallChecked") {
      this.capservice
        .GetProfileDetails("N", this.EmployeeNO, "WBSDetails")
        .subscribe((data) => {
          if (data.length > 0) {
            this.AssignBSEDatas = data;
            this.allItems = data;
            this.setPages(1);
          } else {
            this.displayWBSMark = "none";
          }
        });

      let value;

      this.successfulData.selected = Object.assign({}, AssignBSEData);
      //this.displayWBSMark="none";
      this.successfulData.WBSmarkCallsData.forEach((WBSmarkCall) => {
        if (WBSmarkCall.checked) {
          this.displayWBSMark = "none";
          value = this.successfulData.selected.ChargeCode;
          WBSmarkCall.wbs = value;
        }
      });
    }
  }
  EditWBSCode(WBSmarkCall) {
    this.successfulData.selected = Object.assign({}, WBSmarkCall);
  }
  UpdateWBSCode(idx) {
    this.dataLoader = true;
    let message = "";
    if ($("#grdwbs").val() == "") {
      message = "Please Enter WBSE";
      this.dataLoader = false;
    }

    if (message != "") {
      alert(message);
      this.dataLoader = false;
    } else {
      this.successfulData.selected.wbs = $("#grdwbs").val();
      this.WBSmarkCall.cdrId = this.successfulData.selected.cdrId;
      this.capservice
        .WBSValidation(this.successfulData.selected.wbs)
        .subscribe((data: any) => {
          if (data == "False") {
            alert("Please Enter valid WBS");
            this.dataLoader = false;

            return;
          } else {
            this.capservice
              .AuthCodeDetails(
                this.successfulData.selected.cdrId,
                this.successfulData.selected.wbs,
                "WBSMarkCallUpdate",
                "NULL",
                "NULL",
                "NULL",
                "NULL"
              )
              .subscribe((data) => {
                if (data) {
                  alert("Updated Successfully");
                  this.ShowData("WBSMarkCallDetails");
                  //this.getwbscallsdata();
                  this.dataLoader = false;
                }
              });
          }
        });
    }
  }

  getwbscallsdata() {
    this.capservice
      .GetProfileDetails("N", this.enterpriseid, "WBSMarkCallDetails")
      .subscribe((data) => {
        if (data.length > 0) {
          this.successfulData = { WBSmarkCallsData: data, selected: {} };
        }
      });
  }
  resetWBS() {
    this.successfulData.selected = {};
  }

  SubmitWBSData(AssignBSEData) {
    //
    this.dataLoader = true;
    let value;
    this.successfulData.selected = Object.assign({}, AssignBSEData);
    this.displayWBSMark = "none";
    this.successfulData.WBSmarkCallsData.forEach((WBSmarkCall) => {
      if (WBSmarkCall.checked) {
        value = this.successfulData.selected.ChargeCode;
        WBSmarkCall.wbs = value;
        this.dataLoader = false;
      }
      this.dataLoader = false;
    });
    this.dataLoader = false;
  }

  closeApproveCalls() {
    this.dataLoader = true;
    this.successfulData.selected.approvalStatus = "";
    this.successfulData.selected.approverEid = "";
    this.successfulData.selected.wbs = "";
    this.successfulData.selected.remarks = "";
    this.successfulData.approveCallsDetails.forEach((data) => {
      if (data.checked) {
        this.displayApproveCalls = "none";
        data.checked = false;
        this.selectedAll = false;
        this.dataLoader = false;
      }
      this.dataLoader = false;
    });
    //   this.displayApproveCalls="none";
    //   this.selectedAll=false;
    //   this.successfulData.approveCallsDetails.forEach(data => {
    //     data.checked = false;
    // });

    this.dataLoader = false;
  }

  Action(filter) {
    switch (filter) {
      case "Transfer Approver":
        $("#divApproverName").css("display", "block");
        $("#divWBS").css("display", "none");
        break;
      case "Change WBS":
        $("#divApproverName").css("display", "none");
        $("#divWBS").css("display", "block");
        break;
      default:
        $("#divApproverName").css("display", "none");
        $("#divApproversName").css("display", "none");
        $("#divWBS").css("display", "none");
        $("#divWBS1").css("display", "none");
        break;
    }
  }

  ActionApprove(filters) {
    switch (filters) {
      case "Change WBS":
        $("#divappWBS").css("display", "block");
        break;
      default:
        $("#divappWBS").css("display", "none");
        break;
    }
  }

  getWBSmarkCallTemplate(WBSmarkCall) {
    if (WBSmarkCall.cdrId === this.successfulData.selected.cdrId) {
      return "edit";
    } else return "WBSdisplay";
  }

  PreviewReport(type) {
    this.dataLoader = true;
    let excelcolumnSet = [];
    const excelMarkedColumns = [
      { title: "Date", columnid: "Date" },
      { title: "Time", columnid: "Time" },
      { title: "Extension", columnid: "callingPartyNumber" },
      { title: "Called Number", columnid: "originalCalledPartyNumber" },
      { title: "Duration", columnid: "duration" },
      { title: "Cost", columnid: "callCost" },
      { title: "WBS Element", columnid: "wbs" },
      { title: "Call Status", columnid: "callStatus" },
      { title: "Approver", columnid: "approverEid" },
      { title: "Remarks", columnid: "remarks" },
      { title: "Enterprise Id", columnid: "eId" },
    ];
    const excelApprovedColumns = [
      { title: "Approval Status", columnid: "approvalStatus" },
      { title: "Date", columnid: "Date" },
      { title: "Time", columnid: "Time" },
      { title: "Extension", columnid: "callingPartyNumber" },
      { title: "Called Number", columnid: "originalCalledPartyNumber" },
      { title: "Duration", columnid: "duration" },
      { title: "Cost", columnid: "callCost" },
      { title: "WBS Element", columnid: "wbs" },
      { title: "Call Status", columnid: "callStatus" },
      { title: "Approver", columnid: "approvereid" },
      { title: "Remarks", columnid: "remarks" },
      { title: "Approval Date", columnid: "approvalDate" },
      { title: "Enterprise Id", columnid: "eId" },
    ];
    const excelGenerateReportColumns = [
      { title: "Approval Status", columnid: "approvalStatus" },
      { title: "Date", columnid: "Date" },
      { title: "Time", columnid: "Time" },
      { title: "Extension", columnid: "callingPartyNumber" },
      { title: "Called Number", columnid: "originalCalledPartyNumber" },
      { title: "Duration", columnid: "duration" },
      { title: "Cost", columnid: "callCost" },
      { title: "WBS Element", columnid: "wbs" },
      { title: "Call Status", columnid: "callStatus" },
      { title: "Approver", columnid: "approvereid" },
      { title: "Remarks", columnid: "remarks" },
      { title: "Approval Date", columnid: "approvalDate" },
      { title: "Enterprise Id", columnid: "eId" },
    ];

    switch (type) {
      case "ReportMarkedCallDetails":
        excelcolumnSet = excelMarkedColumns;
        this.dataLoader = false;
        break;
      case "ReportApprovedCallDetails":
        excelcolumnSet = excelApprovedColumns;
        this.dataLoader = false;
        break;
      case "GenerateReportDetails":
        excelcolumnSet = excelGenerateReportColumns;
        this.dataLoader = false;

        break;
    }

    const excelStyles = {
      sheetid: type + "Report",
      headers: true,
      column: {
        style: "font-size:12px;font-family:Arial",
      },
      columns: excelcolumnSet,
    };

    // this.capservice
    //   .GetGenerateProfileDetails("N", this.enterpriseid, type)
    //   .subscribe((data: any) => {
    //     this.RetriveData = data;
    //     //console.log(data);
    //     if (data == 0) {
    //       alert("No data available");
    //       this.dataLoader = false;
    //     }
    //     const sheet = type + "Report.xls";
    //     alasql('SELECT * INTO XLS("' + sheet + '",?) FROM ?', [
    //       excelStyles,
    //       this.RetriveData,
    //     ]);
    //     this.dataLoader = false;
    //   });
    // this.dataLoader = false;
    this.capservice
      .GetGenerateProfileDetails("N", this.enterpriseid, type)
      .subscribe((data: any) => {
        this.RetriveData = data;
        if (data == 0) {
          alert("No data available");
          this.dataLoader = false;
        } else {
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet('Sheet1');
    
          // Add column headers
          const columns = Object.keys(this.RetriveData[0]);
          worksheet.addRow(columns);
    
          // Add data rows
          this.RetriveData.forEach((rowData) => {
            const values = columns.map((col) => rowData[col]);
            worksheet.addRow(values);
          });
    
          // Save the workbook to a file
          const sheet = type + 'Report.xlsx';
          workbook.xlsx.writeFile(sheet)
            .then(() => {
              console.log(`Workbook ${sheet} created successfully.`);
            })
            .catch((error) => {
              console.error('Error creating workbook:', error);
            });
        }
    
        this.dataLoader = false;
      });
    
  }

  PreviewData(type) {
    this.dataLoader = true;
    let excelcolumnSet = [];
    const excelGenerateReportColumns = [
      { title: "Approval Status", columnid: "approvalStatus" },
      { title: "Date", columnid: "Date" },
      { title: "Time", columnid: "Time" },
      { title: "Extension", columnid: "callingPartyNumber" },
      { title: "Called Number", columnid: "originalCalledPartyNumber" },
      { title: "Duration", columnid: "duration" },
      { title: "Cost", columnid: "callCost" },
      { title: "WBS Element", columnid: "wbs" },
      { title: "Call Status", columnid: "callStatus" },
      { title: "Approver", columnid: "approvereid" },
      { title: "Remarks", columnid: "remarks" },
      { title: "Approval Date", columnid: "approvalDate" },
      { title: "Enterprise Id", columnid: "eId" },
    ];

    switch (type) {
      case "GenerateReportDetails":
        excelcolumnSet = excelGenerateReportColumns;
        this.dataLoader = false;
        break;
    }

    const excelStyles = {
      sheetid: type + "Report",
      headers: true,
      column: {
        style: "font-size:12px;font-family:Arial",
      },
      columns: excelcolumnSet,
    };

    // this.capservice
    //   .GetGenerateProfileDetails("N", this.enterpriseid, type)
    //   .subscribe((data: any) => {
    //     this.RetriveData = data;
    //     //console.log(data);
    //     if (data == 0) {
    //       alert("No data available");
    //       this.dataLoader = false;
    //     }
    //     const sheet = type + "Report.xls";
    //     alasql('SELECT * INTO XLS("' + sheet + '",?) FROM ?', [
    //       excelStyles,
    //       this.RetriveData,
    //     ]);
    //     this.dataLoader = false;
    //   });
    // this.dataLoader = false;
    this.capservice
  .GetGenerateProfileDetails("N", this.enterpriseid, type)
  .subscribe((data: any) => {
    this.RetriveData = data;

    if (data == 0) {
      alert("No data available");
      this.dataLoader = false;
    } else {
      // Create a new workbook and add a worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sheet1');

      // Add column headers
      const columns = Object.keys(this.RetriveData[0]);
      worksheet.addRow(columns);

      // Add data rows
      this.RetriveData.forEach((rowData) => {
        const values = columns.map((col) => rowData[col]);
        worksheet.addRow(values);
      });

      // Save the workbook to a file
      const sheet = type + 'Report.xlsx';
      workbook.xlsx.writeFile(sheet)
        .then(() => {
          console.log(`Workbook ${sheet} created successfully.`);
          this.dataLoader = false;
        })
        .catch((error) => {
          console.error('Error creating workbook:', error);
          this.dataLoader = false;
        });
    }
  });
    
  }

  DeleteWBSE(WBSE) {
    this.dataLoader = true;
    this.capservice
      .AuthCodeDetails(
        WBSE,
        this.enterpriseid,
        "WBSE",
        "NULL",
        "NULL",
        "NULL",
        "NULL"
      )
      .subscribe((data) => {
        if (data) {
          alert("Deleted Successfully");
          this.dataLoader = false;
          this.capservice
            .GetAuthcodeRequests("WBSE", this.EmployeeNO, "N")
            .subscribe((data) => {
              if (data.length > 0) {
                this.successfulData = { WBSEData: data, selected: {} };
                this.allItems = data;
                this.setPageWBS(1);
                $("#divWBSEDetails").css("display", "block");
                this.dataLoader = false;
              } else {
                this.successfulData = { WBSEData: data, selected: {} };
                this.allItems = data;
                this.setPageWBS(1);
                $("#divWBSEDetails").css("display", "block");
                this.dataLoader = false;
              }
            });
        }
      });
  }

  selectionClick(callsOption) {
    this.dataLoader = true;
    $("#AlertForBusinessOnly").css("display", "none");
    $("#AlertPeriodExpired").css("display", "none");
    if (callsOption == "MarkCalls") {
      const i = 0;
      // this.capservice.GetProfileDetails(this.Country,this.GDNGS,'UseCase').subscribe(data=>{
      //   this.usecase=data[0].UseCase;
      //   console.log("usecase:"+ this.usecase);
      // });

      //this.usecase='Billing';
      if (this.usecase == "Billing") {
        this.IsShowMarkCalls = true;
        this.IsShowMyMarkCalls = false;
        this.IsShowApproveCalls = false;
        this.IsShowMyApprovedCalls = false;
        this.IsShowWBSEActive = false;
        this.ShowData("MarkCallDetails");
        $("#display").css("display", "block");
        this.dataLoader = false;
      } else if (this.usecase == "Individual chargeback") {
        this.IsShowMarkCalls = true;
        this.IsShowMyMarkCalls = false;
        this.IsShowApproveCalls = false;
        this.IsShowMyApprovedCalls = false;
        this.IsShowWBSEActive = true;
        this.ShowData("WBSMarkCallDetails");
        this.dataLoader = false;
      }
    } else if (callsOption == "MyMarkedCalls") {
      //this.usecase='Billing';

      if (this.usecase == "Billing") {
        this.IsShowMyMarkCalls = true;
        this.IsShowMarkCalls = false;
        this.IsShowApproveCalls = false;
        this.IsShowMyApprovedCalls = false;
        this.ShowData("MarkedCallDetails");
        this.dataLoader = false;
        // $('#displayTblMyMarkCallsDetails').css("display", 'block');
        // $('#displayMarkCallDetails').css("display", 'block');

        // $('#tblMyMarkCallsDetails').css("display", 'block');
        // $('#divMyMarkCallDetails').css("display", 'block');
      } else {
        this.dataLoader = false;
      }
    }
  }

  MarkCallsAdd() {
    this.dataLoader = true;
    let message = "";

    // if ($('#MarkAs').val() == '')
    if (
      this.successfulData.selected.callStatus == "" ||
      this.successfulData.selected.callStatus == null ||
      this.successfulData.selected.callStatus == undefined
    ) {
      message = "Please select MarkAs";
      this.dataLoader = false;
    }
    if (
      this.successfulData.selected.remarks == "" ||
      this.successfulData.selected.remarks == null ||
      this.successfulData.selected.remarks == undefined
    ) {
      message = message + "\n" + "Please Enter Remarks";
      this.dataLoader = false;
    }
    if (this.successfulData.selected.callStatus == "Business") {
      if (
        this.successfulData.selected.wbs == "" ||
        this.successfulData.selected.wbs == null ||
        this.successfulData.selected.wbs == undefined
      ) {
        message = "Please Enter WBS";
        this.divWBSElement = "block";
        this.dataLoader = false;
      }
      if (
        this.successfulData.selected.approverEid == "" ||
        this.successfulData.selected.approverEid == null
      ) {
        message = message + "\n" + "Please Enter Approver";
        this.divApprover = "block";
        this.dataLoader = false;
      }
    }

    if (message != "") {
      alert(message);
      this.dataLoader = false;
    } else if (this.successfulData.selected.Type != "MyMarkCall") {
      this.successfulData.markCalls.forEach((markCall) => {
        this.Count = 0;
        this.CountAll = 1;
        this.maincount = 0;
        this.mainCountSingle = 0;

        if ($("input:checkbox:checked").length > 1) {
          this.maincount = this.successfulData.markCalls.length;
          this.dataLoader = false;
        } else {
          this.mainCountSingle = $("input:checkbox:checked").length;
          this.dataLoader = false;
        }
        if (markCall.checked) {
          if (this.CareerLevel != "Yes") {
            this.CareerLevel = "No";
            this.dataLoader = false;
          }

          this.capservice
            .InsertProfileOtherDetails(
              this.successfulData.selected,
              "MarkCallDetails",
              this.enterpriseid,
              this.CareerLevel,
              markCall.cdrId
            )
            .subscribe((data: any) => {
              if (data == "Please Enter valid WBS") {
                //alert(data);
                this.successfulData.selected.wbs = "";
                this.Count++;
                this.CountAll++;
                this.popup("WBS");
                this.dataLoader = false;
              }
              if (
                data == "Please Enter valid Enterprise ID" ||
                data == "Approver should be Level D and Above"
              ) {
                // alert(data);
                this.Count++;
                this.CountAll++;
                this.successfulData.selected.approverEid = "";
                this.popup("Approver");
                this.dataLoader = false;
              }
              if (data == "Success") {
                this.Count++;
                this.CountAll++;
                this.ShowData("MarkCallDetails");

                this.popup("Submit");
                //alert("Updated successfully");
                this.displayPopUp = "none";
                //this.showModalMarkCalls = false;

                markCall.checked = false;
                this.selectedAll = false;
                this.dataLoader = false;
              }
            });
        }
      });
      this.selectedAll = this.selectedAll;
      this.dataLoader = false;
    } else {
      //console.log(this.successfulData.selected);
      this.capservice
        .InsertProfileOtherDetails(
          this.successfulData.selected,
          "MarkCallDetails",
          this.enterpriseid,
          this.CareerLevel,
          this.successfulData.selected.cdrId
        )
        .subscribe((data: any) => {
          if (
            data == "Please Enter valid WBS" ||
            data == "Please Enter valid Enterprise ID" ||
            data == "Approver should be Level D and Above"
          ) {
            this.successfulData.selected.wbs = "";
            this.successfulData.selected.approverEid = "";
            alert(data);
            this.dataLoader = false;
            return;
          }
          if (data == "Success") {
            this.ShowData("MarkedCallDetails");
            alert("Updated successfully");

            this.displayPopUp = "none";
            this.dataLoader = false;
            //this.showModalMarkCalls = !this.showModalMarkCalls;
          }
        });
    }
  }

  closeModal() {
    this.dataLoader = true;
    this.displayPopUp = "none";
    if (this.successfulData.selected.Type == "MarkCall") {
      this.successfulData.selected.callStatus = "";
      this.successfulData.selected.wbs = "";
      this.successfulData.selected.approverEid = "";
      this.successfulData.selected.remarks = "";
      this.selectedAll = false;
      this.successfulData.markCalls.forEach((markCall) => {
        markCall.checked = false;
        this.dataLoader = false;
      });
    } else if ((this.successfulData.selected.Type = "MyMarkCall")) {
      this.ShowData("MarkedCallDetails");
      this.dataLoader = false;
    }
  }

  closeApprovedCalls() {
    this.dataLoader = true;
    if (
      (this.successfulData.selected.approvalStatus =
        "" ||
        this.successfulData.selected.approvalStatus == "Approve" ||
        this.successfulData.selected.approvalStatus == "Change WBS")
    ) {
      this.displayApprovedCalls = "none";
      this.successfulData.selected.remarks = "";
      this.ShowData("ApprovedCallDetails");
      this.dataLoader = false;
    } else {
      this.displayApprovedCalls = "none";
      this.dataLoader = false;
    }
  }

  getTemplate(markCall) {
    return "display";
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.markCalls = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  setPageone(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.WBSmarkCallsData = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  setPages(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 3);

    // get current page of items
    this.AssignBSEDatas = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  setPagetwo(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.myMarkCalls = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  setPageappcalls(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.approveCallsDetails = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  setPagemyappcalls(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.myApproveCallsDetails = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  setpagereport(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.GenereateReportDetails = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  setPageWBS(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.WBSEData = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  setPageauth(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.MyAuthCodeData = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }
}
